<template>
    <span v-if="!Number.isInteger(temperature)">
        {{ temperature }}
    </span>
    <span v-else-if="temperature <= 5" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'temperature-empty']" size="lg" /> {{ temperature }} °
    </span>
    <span v-else-if="temperature <= 40" class="ui-badge status-badge--medium">
        <font-awesome-icon :icon="['fas', 'temperature-half']" size="lg" /> {{ temperature }} °
    </span>
    <span v-else-if="temperature >= 41" class="ui-badge status-badge--low">
        <font-awesome-icon :icon="['fas', 'temperature-full']" size="lg" /> {{ temperature }} °
    </span>
</template>

<script>
export default {
  props: ['temperature']
}
</script>